// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconInputBreadcrumb = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
            <polygon
                fill="currentColor"
                points="52 8 51.459 8.55 47.628 12.447 47.085 13 46 11.897 46.541 11.346 49.831 8 46.543 4.654 46 4.103 47.085 3 47.626 3.55 51.457 7.447 52 8"
                transform="translate(-46 -3)"
            />
        </svg>
    );
};

export default React.memo(IconInputBreadcrumb);
